import baseTheme from './base-theme';

const lightTheme = {
  ...baseTheme,
  mode: 'light',
  variants: {
    basicPage: {
      color: 'deepGrey',
      backgroundColor: 'white',
    },
    container: {
      backgroundColor: 'white',
    },
    logo: {
      color: 'mediumPurple',
    },
    flexTableCell: {
      flexGrow: 0,
      flexShrink: 0,
    },
  },
  text: {
    title: {
      color: 'midGrey',
    },
    label: {
      color: 'deepGrey',
    },
    primary: {
      color: 'quartz',
      fontWeight: 400,
      fontSize: '13px',
      lineHeight: '135%',
    },
    primaryDisabled: {
      color: 'cloud',
      fontWeight: 400,
      fontSize: '13px',
      lineHeight: '135%',
    },
    primarySmall: {
      color: 'deepGrey',
      fontWeight: 400,
      fontSize: '11px',
      lineHeight: '135%',
    },
    primaryBold: {
      color: 'blackDark',
      fontWeight: 700,
      fontSize: '13px',
      lineHeight: '135%',
    },
    subtitle1: {
      color: 'cloud',
      textTransform: 'uppercase',
      fontWeight: 500,
      fontSize: '13px',
    },
    subtitle2: {
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '18.9px',
      color: 'softMidGrey',
    },
    placeholder: {
      color: 'deepGrey',
      fontWeight: 400,
      fontSize: '13px',
      fontStyle: 'italic',
      lineHeight: '135%',
      opacity: 0.4,
    },
    error: {
      color: 'red',
    },
    success: {
      color: '#7D9E1A',
    },
    warn: {
      color: '#D2A618',
    },
    h1: {
      lineHeight: '120%',
      color: '#444444',
      fontWeight: 400,
      fontSize: '24px',
    },
    h2: {
      fontWeight: 400,
      fontSize: '20px',
      lineHeight: '120%',
      color: '#444444',
    },
    h3: {
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '120%',
      color: '#444444',
    },
    h4: {
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '125%',
      color: '#444444',
    },
    h5: {
      fontWeight: 500,
      fontSize: '13px',
      lineHeight: '120%',
      color: 'cloud',
    },
    p1: {
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '125%',
      color: '#6A6A79',
    },
    p2: {
      fontWeight: 400,
      fontSize: '13px',
      lineHeight: '135%',
      color: 'greyMiddle',
    },
    p3: {
      fontWeight: 400,
      fontSize: '13px',
      lineHeight: '135%',
      color: 'deepGrey',
    },
    breadcrumbs: {
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '125%',
      color: '#929191',
    },
    info: {
      fontStyle: 'italic',
      color: 'black',
      fontWeight: 400,
      fontSize: '13px',
      lineHeight: '18px',
    },
    hoverable: {
      color: 'lavenderDark',
      fontWeight: 400,
      fontSize: '13px',
      cursor: 'pointer',
      borderBottomWidth: '1px',
      borderBottomStyle: 'dashed',
      paddingBottom: '1px',
      '&:hover': {
        borderBottomWidth: '0px',
        borderBottomStyle: 'none',
      },
      error: {
        color: 'red',
        fontWeight: 400,
        fontSize: '13px',
        cursor: 'pointer',
        borderBottomWidth: '1px',
        borderBottomStyle: 'dashed',
        paddingBottom: '1px',
        '&:hover': {
          borderBottomWidth: '0px',
          borderBottomStyle: 'none',
        },
      },
    },
    hoverableBold: {
      color: 'lavenderDark',
      fontWeight: 700,
      fontSize: '13px',
      cursor: 'pointer',
      borderBottomWidth: '1px',
      borderBottomStyle: 'dashed',
      paddingBottom: '1px',
      '&:hover': {
        borderBottomWidth: '0px',
        borderBottomStyle: 'none',
      },
      error: {
        color: 'red',
        fontWeight: 700,
        fontSize: '13px',
        cursor: 'pointer',
        borderBottomWidth: '1px',
        borderBottomStyle: 'dashed',
        paddingBottom: '1px',
        '&:hover': {
          borderBottomWidth: '0px',
          borderBottomStyle: 'none',
        },
      },
    },
    tooltip: {
      fontSize: '12px',
      lineHeight: '16px',
      color: '#000000',
      fontWeight: 400,
    },
  },
};

export default lightTheme;
